import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useForm, ValidationError } from "@formspree/react";

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const [state, handleSubmit] = useForm("xgvezygg");

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      handleSubmit(e);
    } else {
      validator.showMessages();
    }
  };

  if (state.succeeded) {
    return <p>Thank you for your message!</p>;
  }

  return (
    <form onSubmit={submitHandler} className="contact-validation-active">
      <div className="row">
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              type="text"
              name="name"
              value={forms.name}
              onChange={changeHandler}
              placeholder="Your Name"
            />
            {validator.message("name", forms.name, "required|alpha_space")}
            <ValidationError prefix="Name" field="name" errors={state.errors} />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              type="email"
              name="email"
              value={forms.email}
              onChange={changeHandler}
              placeholder="Your Email"
            />
            {validator.message("email", forms.email, "required|email")}
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />
          </div>
        </div>
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              type="text"
              name="phone"
              value={forms.phone}
              onChange={changeHandler}
              placeholder="Your Phone"
            />
            {validator.message("phone", forms.phone, "required|phone")}
            <ValidationError
              prefix="Phone"
              field="phone"
              errors={state.errors}
            />
          </div>
        </div>
        <div className="col col-lg-12 col-12">
          <textarea
            name="message"
            value={forms.message}
            onChange={changeHandler}
            placeholder="Your Message"
          />
          {validator.message("message", forms.message, "required")}
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </div>
      </div>
      <div className="submit-area">
        <button type="submit" className="theme-btn" disabled={state.submitting}>
          Submit Now
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
